module.exports = __webpack_public_path__ + "img/scenario_01.47392579.jpg";